module.exports = __webpack_public_path__ + "static/media/timezone.cc1c8416.svg";